export const LabelBusiness = () => {
  return (
    <label className="nj-label-ultra" data-e2e="label-tier-teams-ultra">
      Business
    </label>
  );
};
